<script lang="ts" setup>
import { nextTick, ref, useTemplateRef } from 'vue';

const props = defineProps<{
  canceling: boolean;
  disabled: boolean;
  responding: boolean;
  sendDisabled: boolean;
}>();

const emit = defineEmits<{
  cancel: [];
  send: [question: string];
}>();

const draft = ref('');
const inputRef = useTemplateRef('chatInput');

const submitDraft = () => {
  const content = draft.value.trim();

  if (!content || props.sendDisabled) {
    return;
  }

  emit('send', content);

  draft.value = '';
};

const focusInput = async () => {
  await nextTick();

  inputRef.value?.focus();
};

defineExpose({
  focusInput,
});
</script>

<template>
  <form class="flex flex-shrink-0 gap-8 border-t-1 border-t-#E4ECF7 border-t-solid bg-#F5F8FC p-14" @submit.prevent="submitDraft">
    <input
      ref="chatInput"
      v-model="draft"
      type="text"
      aria-label="输入想咨询的问题"
      class="h-42 min-w-0 flex-1 border-1 border-#DBE8F7 rounded-10 border-solid bg-white px-12 text-14 text-#292D33 outline-none disabled:cursor-not-allowed focus:border-#1281FF focus:shadow-[0_0_0_3px_rgba(18,129,255,0.12)] disabled:bg-#F1F5F9 <md:text-16 disabled:text-#8A94A6"
      :disabled="props.disabled"
      placeholder="输入你想了解的问题"
    >
    <button
      v-if="props.responding"
      type="button"
      class="h-42 w-72 flex-shrink-0 cursor-pointer border-0 rounded-10 bg-#F04438 text-14 text-white font-700 disabled:cursor-not-allowed disabled:bg-#FDA29B"
      :disabled="props.canceling"
      @click="emit('cancel')"
    >
      {{ props.canceling ? '取消中' : '取消' }}
    </button>
    <button
      v-else
      type="submit"
      class="h-42 w-72 flex-shrink-0 cursor-pointer border-0 rounded-10 bg-#1281FF text-14 text-white font-700 disabled:cursor-not-allowed disabled:bg-#9ECFFF"
      :disabled="props.sendDisabled"
    >
      发送
    </button>
  </form>
</template>
